import captureSentryException from '@/features/app/functions/captureSentryException';
import ipcResponseMessageSchema from '@/features/mobile-app-bridge/constants/ipc-response-message-schema';

export default function parseReactNativeIPCMessage(event: MessageEvent) {
  let jsonMessage;

  try {
    jsonMessage = JSON.parse(event.data);
  } catch (e) {
    captureSentryException(e, {
      extras: {
        data: event.data,
      },
    });
    console.error('Error parsing IPC response message', e);
    return;
  }

  // not from our webview
  if (
    !jsonMessage ||
    typeof jsonMessage !== 'object' ||
    !jsonMessage.from ||
    jsonMessage.from !== 'TIRECLOUD_RN_NATIVE'
  ) {
    captureSentryException(new Error('Foreign IPC message'), {
      extras: {
        jsonMessage,
      },
    });
    console.error('Foreign IPC message', jsonMessage);
    return;
  }

  let result;
  try {
    result = ipcResponseMessageSchema.parse(jsonMessage);
  } catch (e) {
    console.error('Error parsing IPC response message', jsonMessage, e);
    captureSentryException(e, {
      extras: {
        data: jsonMessage,
      },
    });
    return;
  }

  return result;
}
